module.exports = __webpack_public_path__ + "img/logo.d4836058.png";